import { Grid } from "@mui/material";
import clsx from "clsx";
import useStyles from "./styles";
import TicketStatistics from "./TicketStatistics";

const TicketStatus = ({ setTicketType, ticketCount }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={5} className={classes.container}>
      <Grid
        item
        className={clsx(classes.cardItem, classes.firstItem)}
        xs={4}
        onClick={() => setTicketType("self")}
      >
        <TicketStatistics
          index={0}
          title={"My Tickets"}
          subtitle={""}
          attributes={[
            {
              value:
                ticketCount &&
                ticketCount.owned_tickets &&
                ticketCount.owned_tickets.open
                  ? ticketCount.owned_tickets.open
                  : 0,
              name: "Open",
            },
            {
              value:
                ticketCount &&
                ticketCount.owned_tickets &&
                ticketCount.owned_tickets.closed
                  ? ticketCount.owned_tickets.closed
                  : 0,
              name: "Closed",
            },
          ]}
        />
      </Grid>
      <Grid
        item
        className={classes.cardItem}
        xs={4}
        onClick={() => setTicketType("assigned")}
      >
        <TicketStatistics
          index={1}
          title={"Assigned to me"}
          subtitle={""}
          attributes={[
            {
              value:
                ticketCount &&
                ticketCount.assigned_tickets &&
                ticketCount.assigned_tickets.open
                  ? ticketCount.assigned_tickets.open
                  : 0,
              name: "Open",
            },
            {
              value:
                ticketCount &&
                ticketCount.assigned_tickets &&
                ticketCount.assigned_tickets.closed
                  ? ticketCount.assigned_tickets.closed
                  : 0,
              name: "Closed",
            },
          ]}
        />
      </Grid>
      <Grid
        item
        className={classes.cardItem}
        xs={4}
        onClick={() => setTicketType("all")}
      >
        <TicketStatistics
          index={2}
          title={"All Tickets"}
          subtitle={""}
          attributes={[
            {
              value:
                ticketCount &&
                ticketCount.all_tickets &&
                ticketCount.all_tickets.open
                  ? ticketCount.all_tickets.open
                  : 0,
              name: "Open",
            },
            {
              value:
                ticketCount &&
                ticketCount.all_tickets &&
                ticketCount.all_tickets.closed
                  ? ticketCount.all_tickets.closed
                  : 0,
              name: "Closed",
            },
          ]}
        />
      </Grid>
    </Grid>
  );
};

export default TicketStatus;
